import { ReactNode, useContext } from 'react';

import { trackAthenaFollowingView } from '@/common/analytics/gtm/follow/followButtonAnalytics';
import { convertStringToGTMSlug } from '@/common/analytics/gtm/shared/convertStringToGTMSlug';
import { trackFeedToggle } from '@/common/analytics/MasonryFeeds/MasonryFeeds.analytics';
import PillsPicker from '@/common/components/PillsPicker/PillsPicker';
import { useAthena } from '@/common/hooks/useAthena/useAthena';
import { useCurrentPage } from '@/common/routes/ElysiumKnownPages';
import { AuthContext } from '@/contexts/auth/AuthContext';

export interface FeedContents {
  heading: string;
  content: ReactNode;
}

interface MasonryFeedsSelectorProps {
  feedContents: FeedContents[];
  activeTab: number;
  handleFeedChange: (index: number) => void;
}

const MasonryFeedsSelector = ({
  feedContents,
  activeTab,
  handleFeedChange,
}: MasonryFeedsSelectorProps) => {
  const { userInfo } = useContext(AuthContext);
  const { pushEvent } = useAthena();
  const pageConfig = useCurrentPage();

  const headings = feedContents.map((content) => {
    return { label: content.heading, testId: content.heading };
  });

  const onTabItemClick = (index: number) => {
    handleFeedChange(index);
    trackFeedToggle(convertStringToGTMSlug(headings[index].label));

    const pageType = pageConfig.analyticsGaName;

    if (feedContents[index].heading === 'following') {
      trackAthenaFollowingView(pushEvent, pageType, userInfo?.id);
    }
  };

  return (
    <>
      <PillsPicker activeOption={activeTab} onChange={onTabItemClick} options={headings} />
      {feedContents[activeTab].content}
    </>
  );
};

export default MasonryFeedsSelector;
